import { useSampleContext } from "../../contexts";
import { useReachbackContext } from "../../contexts/ReachbackContext";
import ScanWizard from "./ScanWizard";
import CustomModalB from "../ui/ModalB";
import { useGetMeasurementBulk, useValidateSample } from "../../api";

const WizardBulk = ({ step, steps, changeStep, pageID }) => {
  const { initWasatchBulk, device } = useSampleContext();
  const { updateSubmittedErrorsB, addReachbackReason, removeReachbackReason } =
    useReachbackContext();

  return (
    <ScanWizard
      title='Amplifi ID Bulk Scan'
      subtitle='If Bulk Scan is not applicable, press "Skip Bulk Scan".'
      step={step}
      pageID={pageID}
      changeStep={changeStep}
      deviceId={device?.deviceId}
      getMeasurementHook={useGetMeasurementBulk}
      scanType='bulk-burst'
      validateHook={useValidateSample}
      initContextScan={initWasatchBulk}
      reachback={{
        updateSubmittedErrors: updateSubmittedErrorsB,
        addReachbackReason,
        removeReachbackReason,
        reasonKey: "bulkErrorCheck",
      }}
      infoModal={({ showModal, handleClose }) => (
        <CustomModalB showModal={showModal} handleClose={handleClose} />
      )}
    />
  );
};

export default WizardBulk;
